import { useState } from 'react';

import Box from '@mui/material/Box';
import { Container } from '@mui/material';

import Logo from 'src/components/logo';

import Nav from './nav';
import LanguagePopover from './common/language-popover';

// ----------------------------------------------------------------------

type NoNavLayoutProps = {
  children?: React.ReactNode;
  showLanguage?: boolean;
};

export function NoNavLayout({ children, showLanguage = true }: NoNavLayoutProps) {
  return (
    <Container sx={{ p: 0 }}>
      <Box
        sx={{
          position: 'fixed',
          top: 0,
          left: 0,
          width: '100%',
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          p: { xs: 1, md: 2 },
          zIndex: 1000, // Ensure it stays on top of other content
        }}
      >
        <Logo
          sx={{
            ml: { xs: 1, md: 2 },
          }}
        />
        {showLanguage && (
          <Box sx={{ mr: { xs: 1, md: 2 } }}>
            <LanguagePopover />
          </Box>
        )}
      </Box>

      <Container sx={{ height: '100%', p: 0 }}>{children}</Container>
    </Container>
  );
}

type AppLayoutProps = {
  children?: React.ReactNode;
};

export function AppLayout({ children }: AppLayoutProps) {
  const [openNav, setOpenNav] = useState(false);

  return (
    <Box
      sx={{
        minHeight: 1,
        display: 'flex',
        maxHeight: '100vh',
        flexDirection: { xs: 'column', lg: 'row' },
      }}
    >
      <Nav openNav={openNav} setOpenNav={setOpenNav} />

      <Container sx={{ p: 0, flex: 1 }}>{children}</Container>
    </Box>
  );
}
